import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '@environments/environment';
import * as _ from 'lodash';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CartService } from './cart.service';

@Injectable({
    providedIn: 'root',
})
export class PropertyService {

    constructor(
        private http: HttpClient
    ) { }


    getPropertylist(pageType) {
        if(pageType=="ownerProperty"){
            return this.http.get<any>(`${environment.apiUrl}/property-contract/owner/`);

        }else{

            return this.http.get<any>(`${environment.apiUrl}/property-contract/`);
        }
    }

    getPropertyDetails(pageType,id) {
        if(pageType=="ownerProperty"){

            return this.http.get<any>(`${environment.apiUrl}/property-contract/owner/${id}`).pipe(
                catchError(error => {

                    return of(error)
                }));
        }else{

            return this.http.get<any>(`${environment.apiUrl}/property-contract/${id}`).pipe(
                catchError(error => {

                    return of(error)
                }));
        }
    }

    addCommunication(id, formData) {
        return this.http.post<any>(
            `${environment.apiUrl}/quotations/add-communication/${id}`,
            formData
        );
    }

}
